export default __webpack_public_path__ + "static/media/t23.min.520d1649.png";